import { Status } from 'civic-champs-shared/api/hooks'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { OpportunityTemplateSurvey } from 'volunteering/opportunities/interfaces'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

export const useGetOpportunityTemplateSurveys = (): [
  (opportunityId: number) => Promise<OpportunityTemplateSurvey[]>,
  Status<OpportunityTemplateSurvey[]>,
] => {
  const org = useCurrentOrg()
  const [request, status] = useFetchRefactored<OpportunityTemplateSurvey[]>({
    errorMessage: 'Error Fetching Template Surveys',
    emptyValue: [],
  })

  const fetchOpportunityTemplateGroups = useCallback(
    (opportunityId: number) => {
      return request({
        method: 'get',
        url: `/organizations/${org.id}/opportunity_templates/${opportunityId}/surveys`,
      })
    },
    [org.id, request],
  )

  return [fetchOpportunityTemplateGroups, status]
}

export default useGetOpportunityTemplateSurveys
